import React from 'react';
import cn from 'classnames';
import { LABEL } from '@veriables';
import { aboutFields } from '@components/common/OptionsMenus/displayFields';
import FullWidthModal from '@components/common/Modal/FullWidthModal';
import ModalHeader from '@components/common/ModalHeader';
import { TouchableButton } from '../../../common/Touchable';
import style from '@components/common/OptionsMenus/optionMenuCopy.module.scss';

const AboutModal = ({
  isOpen,
  onClose,
  serverAppTheme,
  aboutData,
  orderingPortraitOrientation,
}) => {
  if (!isOpen || !aboutData?.val) return null;

  return (
    <FullWidthModal
      isOpen={isOpen}
      isModalCenter
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        pointerEvents: 'auto',
        backgroundColor: serverAppTheme?.popUp_bg,
        backgroundClip: 'padding-box',
        height: '100%',
      }}
      customClass="h-100 w-100"
      customClass2="h-100 w-100"
      noBackground
    >
      <ModalHeader tileHeader={LABEL().ABOUT} />
      <div
        className={cn(
          'col-12 px-3 d-flex justify-content-center align-items-center',
          !orderingPortraitOrientation ? 'mt-3' : ''
        )}
      >
        <div
          className={cn(
            style.card_container,
            'rounded p-3 fs_14',
            orderingPortraitOrientation ? 'col-12' : 'col-6'
          )}
        >
          {aboutFields.map((e) => (
            <div key={e.key} className="d-flex py-2">
              <div className="px-0 col-6 text-left fs_20">{e.name}</div>
              <div className="px-0 col-6 text-right fw-700 fs_20">
                {e.prefix} {aboutData.val[e.key]}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div
        className={cn(
          'mt-4 col-12 d-flex justify-content-center align-items-center',
          !orderingPortraitOrientation ? style.closebtn : style.about_close_button
        )}
      >
        <TouchableButton
          className={cn(
            'btn-ripple fs_24',
            orderingPortraitOrientation ? 'btn68' : 'btn44',
            style.closebutton
          )}
          onClick={onClose}
        >
          {LABEL().ABOUT_CLOSE}
        </TouchableButton>
      </div>
    </FullWidthModal>
  );
};

export default React.memo(AboutModal);
